// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staff-registration {
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 3%;
  background: #f3f4f6;
}
.staff-registration__head {
  display: flex;
}
.staff-registration__head__right {
  margin-left: auto;
}
.staff-registration__head__breadcrumb {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.staff-registration__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.staff-registration__head__text__current {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #49ae9e;
}
.staff-registration__head__text__total {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #c1c1c1;
}
.staff-registration__head__button {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background: white;
  padding: 5%;
  height: 50px;
  width: 150px;
  border: 1px solid #49ae9e;
  border-radius: 8px;
  cursor: pointer;
}
.staff-registration__head__input {
  border: none;
  background: white;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #49ae9e;
}
.staff-registration__card {
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-top: 40px;
  display: flex;
}
.staff-registration__card__left {
  width: 65%;
  border-right: 1px solid #e9e9e9;
}
.staff-registration__card__right {
  width: 35%;
  padding-left: 40px;
  padding-top: 100px;
  padding-right: 90px;
}
.staff-registration__payment {
  padding: 5%;
}
.staff-registration__payment__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.staff-registration__payment__body {
  margin-top: 10px;
}
.staff-registration__payment__body__application-start {
  position: relative;
}
.staff-registration__payment__body__select-template-head {
  margin-top: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__payment__body__select-template-select {
  display: flex;
}
.staff-registration__payment__body__text-template {
  border: 1px solid #e9e9e9;
  border-radius: 0px 8px 8px 0px;
  width: 50%;
  padding-top: 18px;
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #075453;
}
.staff-registration__payment__body__input {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 0px 0px 8px;
}
.staff-registration__payment__body__input2 {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 0px 0px 8px;
}
.staff-registration__payment__body__input3 {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 8px 8px;
}
.staff-registration__payment__body__input4 {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 8px 8px;
}
.staff-registration__payment__body__income-report {
  margin-top: 20px;
  display: flex;
}
.staff-registration__payment__body__income-report__checkbox {
  margin-right: 30px;
}
.staff-registration__payment__body__add-new-template {
  margin-top: 20px;
}
.staff-registration__payment__body__add-new-template-input-select {
  width: 30%;
}
.staff-registration__payment__body__add-new-template-input {
  display: flex;
}
.staff-registration__payment__body__label {
  display: flex;
  align-items: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__payment__body__holiday-allowance {
  margin-top: 30px;
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.staff-registration__payment__body__holiday-allowance__add-weekly {
  display: flex;
  margin-left: auto;
}
.staff-registration__payment__body__holiday-allowance__labour-std-act {
  margin-right: 10px;
}
.staff-registration__payment__body__holiday-allowance__input-container {
  display: flex;
  position: relative;
}
.staff-registration__payment__body__holiday-allowance__input {
  border: none;
  border-bottom: 1px solid #292d31;
  width: 100px;
  padding-right: 35px;
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.staff-registration__payment__body__holiday-allowance__input-text {
  display: inline-block;
  position: absolute;
  right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: #333333;
}
.staff-registration__payment__body__amount {
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 0px 8px 8px 0px;
  width: 250%;
}
.staff-registration__payment__body__percentage {
  position: relative;
  z-index: 0;
  width: 100%;
}
.staff-registration__payment__body__percentage__icon {
  position: absolute;
  right: 20px;
  top: 20px;
}
.staff-registration__payment__body__pay-percentage-input {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 0px 8px 8px 0px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding-left: 10px;
}
.staff-registration__payment__body__existing-template {
  margin-top: 30px;
}
.staff-registration__payment__body__existing-template__td {
  width: 100px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
}
.staff-registration__payment__body__existing-template__text {
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #505054;
}
.staff-registration__payment__body__existing-template__label {
  margin-right: 10px;
}
.staff-registration__contract {
  padding: 3%;
}
.staff-registration__contract__up {
  display: flex;
}
.staff-registration__contract__left {
  width: 65%;
}
.staff-registration__contract__left-enabled {
  width: 65%;
  border-right: 1px solid #e9e9e9;
}
.staff-registration__contract__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.staff-registration__contract__toggle {
  margin-left: 20px;
}
.staff-registration__contract__body__date-range {
  display: flex;
}
.staff-registration__contract__body__start {
  width: 50%;
  margin-right: 10px;
}
.staff-registration__contract__body__pay-percentage {
  margin-top: 20px;
}
.staff-registration__contract__body__pay-percentage-head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__contract__body__pay-percentage-input-set {
  display: flex;
}
.staff-registration__contract__body__pay-percentage-input-text {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border: 1px solid #e9e9e9;
  border-radius: 8px 0px 0px 8px;
  width: 30%;
  height: 56px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: #333333;
}
.staff-registration__contract__body__pay-percentage-input {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 0px 8px 8px 0px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding-left: 10px;
}
.staff-registration__contract__body__percentage {
  position: relative;
  z-index: 0;
  width: 100%;
}
.staff-registration__contract__body__percentage__icon {
  position: absolute;
  right: 20px;
  top: 15px;
}
.staff-registration__permission {
  padding: 5%;
}
.staff-registration__permission__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.staff-registration__permission__body__select {
  margin-top: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__permission__togglers__t1 {
  display: flex;
  margin-top: 40px;
}
.staff-registration__permission__togglers__t1__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #505054;
  margin-top: 15px;
}
.staff-registration__permission__togglers__t1__toggler {
  margin-left: auto;
}
.staff-registration__right-top {
  padding-top: 40px;
}
.staff-registration__right-heads {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__right-body {
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
  flex-wrap: wrap;
}
.staff-registration__schedule-right__head {
  margin-top: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__schedule {
  padding: 5%;
}
.staff-registration__schedule__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.staff-registration__schedule__body {
  margin-top: 30px;
}
.staff-registration__schedule__body__select-template-head {
  margin-top: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__schedule__body__select-template-select {
  display: flex;
}
.staff-registration__schedule__body__text-template {
  border: 1px solid #e9e9e9;
  border-radius: 0px 8px 8px 0px;
  width: 50%;
  padding-top: 20px;
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #075453;
}
.staff-registration__schedule__body__input {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 0px 0px 8px;
}
.staff-registration__schedule__body__input2 {
  width: 30%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 0px 0px 8px;
}
.staff-registration__schedule__body__input3 {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 0px 8px;
}
.staff-registration__schedule__body__input4 {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 8px 8px;
}
.staff-registration__schedule__body__add-new-template {
  margin-top: 30px;
}
.staff-registration__schedule__body__add-new-template-input {
  display: flex;
}
.staff-registration__schedule__body__label {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__schedule__body__holiday-allowance {
  margin-top: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.staff-registration__schedule__body__amount {
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 0px 8px 8px 0px;
  width: 250%;
}
.staff-registration__schedule__body__percentage {
  position: relative;
  z-index: 0;
  width: 100%;
}
.staff-registration__schedule__body__percentage__icon {
  position: absolute;
  right: 20px;
  top: 15px;
}
.staff-registration__schedule__body__pay-percentage-input {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 0px 8px 8px 0px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding-left: 10px;
}
.staff-registration__schedule__body__existing-template {
  margin-top: 30px;
}
.staff-registration__schedule__body__existing-template__td {
  width: 100px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
}
.staff-registration__schedule__body__existing-template__text {
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #505054;
}
.staff-registration__schedule__body__existing-template__label {
  margin-right: 10px;
}
.staff-registration__schedule__extend {
  margin-top: 40px;
}
.staff-registration__schedule__extend__way-of-work {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  align-items: center;
}
.staff-registration__schedule__extend__way-of-work__left {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__schedule__extend__way-of-work__span {
  margin-left: 10px;
}
.staff-registration__schedule__extend__way-of-work__right {
  width: 75%;
}
.staff-registration__schedule__extend__way-of-work__time {
  display: flex;
  width: 100%;
}
.staff-registration__schedule__extend__way-of-work__rest-include {
  width: 100%;
  padding-left: 10px;
}
.staff-registration__schedule__extend__way-of-work__buttons {
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #505054;
}
.staff-registration__schedule__extend__way-of-work__fix {
  border-radius: 8px 0px 0px 8px;
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  color: #505054;
}
.staff-registration__schedule__extend__way-of-work__fix-selected {
  border-radius: 8px 0px 0px 8px;
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  background: #4a515e;
  text-align: center;
  padding-top: 15px;
  color: #ffffff;
}
.staff-registration__schedule__extend__way-of-work__fix:hover {
  border-radius: 8px 0px 0px 8px;
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  background: #4a515e;
  color: #ffffff;
  cursor: pointer;
}
.staff-registration__schedule__extend__way-of-work__optional {
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  color: #505054;
}
.staff-registration__schedule__extend__way-of-work__optional-selected {
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  background: #4a515e;
  color: #ffffff;
}
.staff-registration__schedule__extend__way-of-work__optional:hover {
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  background: #4a515e;
  color: #ffffff;
  cursor: pointer;
}
.staff-registration__schedule__extend__way-of-work__autonomous {
  border-radius: 0px 8px 8px 0px;
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  color: #505054;
}
.staff-registration__schedule__extend__way-of-work__autonomous-selected {
  border-radius: 0px 8px 8px 0px;
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  background: #4a515e;
  color: #ffffff;
}
.staff-registration__schedule__extend__way-of-work__autonomous:hover {
  border-radius: 0px 8px 8px 0px;
  height: 56px;
  border: 1px solid #e1e1e1;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  background: #4a515e;
  color: #ffffff;
  cursor: pointer;
}
.staff-registration__schedule__extend__way-of-work__info-message {
  margin-top: 5px;
  display: flex;
  align-items: center;
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #999999;
}
.staff-registration__schedule__extend__way-of-work__info-message__text {
  margin-left: 5px;
}
.staff-registration__schedule__extend__optional {
  margin-top: 20px;
}
.staff-registration__schedule__extend__optional__left {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-top: 20px;
}
.staff-registration__schedule__extend__optional__span {
  margin-left: 10px;
}
.staff-registration__schedule__extend__optional__content {
  margin-top: 20px;
  background: #fafafa;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  padding: 0px 20px 20px 20px;
}
.staff-registration__schedule__extend__optional__row {
  display: flex;
  margin-top: 20px;
}
.staff-registration__schedule__extend__optional__left {
  width: 25%;
  display: flex;
  align-content: center;
}
.staff-registration__schedule__extend__optional__text {
  padding-left: 10px;
  padding-right: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__schedule__extend__optional__right {
  display: flex;
  width: 75%;
}
.staff-registration__schedule__extend__optional__button {
  width: 100%;
}
.staff-registration__schedule__extend__optional__recurring-schedule-card {
  margin-top: 20px;
}
.staff-registration__schedule__extend__template__left {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-top: 20px;
}
.staff-registration__schedule__extend__template__span {
  margin-left: 10px;
}
.staff-registration__schedule__extend__template__label {
  margin-top: 20px;
}
.staff-registration__schedule__extend__template__td {
  padding-left: 20px;
}
.staff-registration__schedule__extend__template__text {
  margin-top: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.staff-registration__list__plus {
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  align-items: center;
}
.staff-registration__list__plus__button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  height: 40px;
  width: 120px;
  color: #49ae9e;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #49ae9e;
  border-radius: 8px;
  cursor: pointer;
}
.staff-registration__list .scheduleInfo .section {
  display: flex;
  margin-top: 20px;
}
.staff-registration__list .scheduleInfo .label {
  text-align: left !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  position: relative;
  width: 132px;
}
.staff-registration__list .scheduleInfo .value {
  flex: 1 1;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  display: inline-block;
}
.staff-registration__list .scheduleInfo .remove button {
  padding: 3px;
  color: #e47c77;
  font-size: 13px;
}
.staff-registration__list .scheduleInfo .remove button:hover {
  text-decoration: underline;
}

.css-1p3m7a8-multiValue {
  background: none !important;
}

.react-select__multi-value__remove {
  display: none !important;
}

.whiteSpace {
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/screens/staff-registration/staff-registration.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AACJ;AACI;EACI,aAAA;AACR;AACQ;EACI,iBAAA;AACZ;AAEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ;AAGY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADhB;AAIY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFhB;AAMQ;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EAEA,yBAAA;EACA,kBAAA;EACA,eAAA;AALZ;AAQQ;EACI,YAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAPZ;AAWI;EACI,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AATR;AAWQ;EACI,UAAA;EACA,+BAAA;AATZ;AAYQ;EACI,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAVZ;AAcI;EACI,WAAA;AAZR;AAcQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAZZ;AAeQ;EACI,gBAAA;AAbZ;AAeY;EACI,kBAAA;AAbhB;AAeY;EACI,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAdhB;AAiBY;EACI,aAAA;AAfhB;AAkBY;EACI,yBAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAjBhB;AAoBY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAlBhB;AAqBY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAnBhB;AAsBY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AApBhB;AAuBY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AArBhB;AAwBY;EACI,gBAAA;EACA,aAAA;AAtBhB;AAwBgB;EACI,kBAAA;AAtBpB;AA0BY;EACI,gBAAA;AAxBhB;AA2BY;EACI,UAAA;AAzBhB;AA4BY;EACI,aAAA;AA1BhB;AA6BY;EACI,aAAA;EACA,mBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA5BhB;AA+BY;EACI,gBAAA;EACA,aAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9BhB;AAgCgB;EACI,aAAA;EACA,iBAAA;AA9BpB;AAiCgB;EACI,kBAAA;AA/BpB;AAkCgB;EACI,aAAA;EACA,kBAAA;AAhCpB;AAmCgB;EACI,YAAA;EACA,gCAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAlCpB;AAqCgB;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAnCpB;AAuCY;EACI,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;AArChB;AAwCY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AAtChB;AAwCgB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAtCpB;AA0CY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAzChB;AA4CY;EACI,gBAAA;AA1ChB;AA4CgB;EACI,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1CpB;AA6CgB;EACI,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA3CpB;AA8CgB;EACI,kBAAA;AA5CpB;AAkDI;EACI,WAAA;AAhDR;AAkDQ;EACI,aAAA;AAhDZ;AAmDQ;EACI,UAAA;AAjDZ;AAoDQ;EACI,UAAA;EACA,+BAAA;AAlDZ;AAqDQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnDZ;AAsDQ;EACI,iBAAA;AApDZ;AAwDY;EACI,aAAA;AAtDhB;AAyDY;EACI,UAAA;EACA,kBAAA;AAvDhB;AA6DY;EACI,gBAAA;AA3DhB;AA8DY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA5DhB;AA+DY;EACI,aAAA;AA7DhB;AAgEY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA/DhB;AAkEY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjEhB;AAoEY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AAlEhB;AAoEgB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAlEpB;AAwEI;EACI,WAAA;AAtER;AAwEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtEZ;AA0EY;EACI,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzEhB;AA8EY;EACI,aAAA;EACA,gBAAA;AA5EhB;AA8EgB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,gBAAA;AA7EpB;AAgFgB;EACI,iBAAA;AA9EpB;AAoFI;EACI,iBAAA;AAlFR;AAqFI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnFR;AAsFI;EACI,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AApFR;AAwFQ;EACI,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvFZ;AA2FI;EACI,WAAA;AAzFR;AA2FQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzFZ;AA4FQ;EACI,gBAAA;AA1FZ;AA4FY;EACI,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA3FhB;AA8FY;EACI,aAAA;AA5FhB;AA+FY;EACI,yBAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA9FhB;AAiGY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AA/FhB;AAkGY;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAhGhB;AAmGY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAjGhB;AAoGY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAlGhB;AAqGY;EACI,gBAAA;AAnGhB;AAsGY;EACI,aAAA;AApGhB;AAuGY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArGhB;AAwGY;EACI,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvGhB;AA0GY;EACI,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;AAxGhB;AA2GY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AAzGhB;AA2GgB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAzGpB;AA6GY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA5GhB;AA+GY;EACI,gBAAA;AA7GhB;AA+GgB;EACI,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7GpB;AAgHgB;EACI,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9GpB;AAiHgB;EACI,kBAAA;AA/GpB;AAoHQ;EACI,gBAAA;AAlHZ;AAoHY;EACI,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AAlHhB;AAoHgB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlHpB;AAqHgB;EACI,iBAAA;AAnHpB;AAsHgB;EACI,UAAA;AApHpB;AAuHgB;EACI,aAAA;EACA,WAAA;AArHpB;AAwHgB;EACI,WAAA;EACA,kBAAA;AAtHpB;AAyHgB;EACI,aAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAxHpB;AA2HgB;EACI,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAzHpB;AA4HgB;EACI,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA1HpB;AA6HgB;EACI,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA3HpB;AA8HgB;EACI,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA5HpB;AA+HgB;EACI,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AA7HpB;AAgIgB;EACI,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA9HpB;AAiIgB;EACI,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA/HpB;AAkIgB;EACI,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAhIpB;AAmIgB;EACI,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAjIpB;AAoIgB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAnIpB;AAqIoB;EACI,gBAAA;AAnIxB;AAwIY;EACI,gBAAA;AAtIhB;AAwIgB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAtIpB;AAyIgB;EACI,iBAAA;AAvIpB;AA0IgB;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AAxIpB;AA2IgB;EACI,aAAA;EACA,gBAAA;AAzIpB;AA4IgB;EACI,UAAA;EACA,aAAA;EACA,qBAAA;AA1IpB;AA6IgB;EACI,kBAAA;EACA,mBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA5IpB;AA+IgB;EACI,aAAA;EACA,UAAA;AA7IpB;AAgJgB;EACI,WAAA;AA9IpB;AAiJgB;EACI,gBAAA;AA/IpB;AAoJgB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAlJpB;AAqJgB;EACI,iBAAA;AAnJpB;AAsJgB;EACI,gBAAA;AApJpB;AAuJgB;EACI,kBAAA;AArJpB;AAwJgB;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtJpB;AA8JQ;EAEI,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AA7JZ;AA+JY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,eAAA;AA9JhB;AAoKY;EACI,aAAA;EACA,gBAAA;AAlKhB;AAqKY;EACI,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAnKhB;AAsKY;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AApKhB;AAwKgB;EACI,YAAA;EACA,cAAA;EACA,eAAA;AAtKpB;AAwKoB;EACI,0BAAA;AAtKxB;;AA8KA;EACI,2BAAA;AA3KJ;;AA8KA;EACI,wBAAA;AA3KJ;;AA8KA;EACI,YAAA;AA3KJ","sourcesContent":[".staff-registration {\n    padding-left: 10%;\n    padding-right: 10%;\n    padding-top: 3%;\n    background: #f3f4f6;\n\n    &__head {\n        display: flex;\n\n        &__right {\n            margin-left: auto;\n        }\n\n        &__breadcrumb {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n        }\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n\n            &__current {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 28px;\n                line-height: 38px;\n                color: #49ae9e;\n            }\n\n            &__total {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 28px;\n                line-height: 38px;\n                color: #c1c1c1;\n            }\n        }\n\n        &__button {\n            display: flex;\n            align-items: center;\n            justify-content: space-evenly;\n            background: white;\n            padding: 5%;\n            height: 50px;\n            width: 150px;\n\n            border: 1px solid #49ae9e;\n            border-radius: 8px;\n            cursor: pointer;\n        }\n\n        &__input {\n            border: none;\n            background: white;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            text-align: center;\n            color: #49ae9e;\n        }\n    }\n\n    &__card {\n        background-color: #ffffff;\n        border: 1px solid #f3f5f6;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        margin-top: 40px;\n        display: flex;\n\n        &__left {\n            width: 65%;\n            border-right: 1px solid #e9e9e9;\n        }\n\n        &__right {\n            width: 35%;\n            padding-left: 40px;\n            padding-top: 100px;\n            padding-right: 90px;\n        }\n    }\n\n    &__payment {\n        padding: 5%;\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 30px;\n            color: #333333;\n        }\n\n        &__body {\n            margin-top: 10px;\n\n            &__application-start {\n                position: relative;\n            }\n            &__select-template-head {\n                margin-top: 20px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__select-template-select {\n                display: flex;\n            }\n\n            &__text-template {\n                border: 1px solid #e9e9e9;\n                border-radius: 0px 8px 8px 0px;\n                width: 50%;\n                padding-top: 18px;\n                text-align: center;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 22px;\n                text-align: center;\n                color: #075453;\n            }\n\n            &__input {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 0px 0px 8px;\n            }\n\n            &__input2 {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 0px 0px 8px;\n            }\n\n            &__input3 {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 8px 8px 8px;\n            }\n\n            &__input4 {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 8px 8px 8px;\n            }\n\n            &__income-report {\n                margin-top: 20px;\n                display: flex;\n\n                &__checkbox {\n                    margin-right: 30px;\n                }\n            }\n\n            &__add-new-template {\n                margin-top: 20px;\n            }\n\n            &__add-new-template-input-select {\n                width: 30%;\n            }\n\n            &__add-new-template-input {\n                display: flex;\n            }\n\n            &__label {\n                display: flex;\n                align-items: center;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__holiday-allowance {\n                margin-top: 30px;\n                display: flex;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 24px;\n                color: #333333;\n\n                &__add-weekly {\n                    display: flex;\n                    margin-left: auto;\n                }\n\n                &__labour-std-act {\n                    margin-right: 10px;\n                }\n\n                &__input-container {\n                    display: flex;\n                    position: relative;\n                }\n\n                &__input {\n                    border: none;\n                    border-bottom: 1px solid #292d31;\n                    width: 100px;\n                    padding-right: 35px;\n                    position: relative;\n\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 16px;\n                    color: #333333;\n                }\n\n                &__input-text {\n                    display: inline-block;\n                    position: absolute;\n                    right: 5px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    text-align: right;\n                    color: #333333;\n                }\n            }\n\n            &__amount {\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 0px 8px 8px 0px;\n                width: 250%;\n            }\n\n            &__percentage {\n                position: relative;\n                z-index: 0;\n                width: 100%;\n\n                &__icon {\n                    position: absolute;\n                    right: 20px;\n                    top: 20px;\n                }\n            }\n\n            &__pay-percentage-input {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 0px 8px 8px 0px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 24px;\n                padding-left: 10px;\n            }\n\n            &__existing-template {\n                margin-top: 30px;\n\n                &__td {\n                    width: 100px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 500;\n                    font-size: 16px;\n                    line-height: 22px;\n                    color: #999999;\n                }\n\n                &__text {\n                    display: flex;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 16px;\n                    line-height: 24px;\n                    color: #505054;\n                }\n\n                &__label {\n                    margin-right: 10px;\n                }\n            }\n        }\n    }\n\n    &__contract {\n        padding: 3%;\n\n        &__up {\n            display: flex;\n        }\n\n        &__left {\n            width: 65%;\n        }\n\n        &__left-enabled {\n            width: 65%;\n            border-right: 1px solid #e9e9e9;\n        }\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 30px;\n            color: #333333;\n        }\n\n        &__toggle {\n            margin-left: 20px;\n        }\n\n        &__body {\n            &__date-range {\n                display: flex;\n            }\n\n            &__start {\n                width: 50%;\n                margin-right: 10px;\n            }\n\n            &__end {\n            }\n\n            &__pay-percentage {\n                margin-top: 20px;\n            }\n\n            &__pay-percentage-head {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__pay-percentage-input-set {\n                display: flex;\n            }\n\n            &__pay-percentage-input-text {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                background: #fafafa;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 0px 0px 8px;\n                width: 30%;\n                height: 56px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                line-height: 24px;\n                text-align: center;\n                color: #333333;\n            }\n\n            &__pay-percentage-input {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 0px 8px 8px 0px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 24px;\n                padding-left: 10px;\n            }\n\n            &__percentage {\n                position: relative;\n                z-index: 0;\n                width: 100%;\n\n                &__icon {\n                    position: absolute;\n                    right: 20px;\n                    top: 15px;\n                }\n            }\n        }\n    }\n\n    &__permission {\n        padding: 5%;\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 30px;\n            color: #333333;\n        }\n\n        &__body {\n            &__select {\n                margin-top: 30px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n        }\n\n        &__togglers {\n            &__t1 {\n                display: flex;\n                margin-top: 40px;\n\n                &__text {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 16px;\n                    line-height: 24px;\n                    color: #505054;\n\n                    margin-top: 15px;\n                }\n\n                &__toggler {\n                    margin-left: auto;\n                }\n            }\n        }\n    }\n\n    &__right-top {\n        padding-top: 40px;\n    }\n\n    &__right-heads {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n\n    &__right-body {\n        display: flex;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n        flex-wrap: wrap;\n    }\n\n    &__schedule-right {\n        &__head {\n            margin-top: 30px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n    }\n\n    &__schedule {\n        padding: 5%;\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 30px;\n            color: #333333;\n        }\n\n        &__body {\n            margin-top: 30px;\n\n            &__select-template-head {\n                margin-top: 20px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__select-template-select {\n                display: flex;\n            }\n\n            &__text-template {\n                border: 1px solid #e9e9e9;\n                border-radius: 0px 8px 8px 0px;\n                width: 50%;\n                padding-top: 20px;\n                text-align: center;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 22px;\n                text-align: center;\n                color: #075453;\n            }\n\n            &__input {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 0px 0px 8px;\n            }\n\n            &__input2 {\n                width: 30%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 0px 0px 8px;\n            }\n\n            &__input3 {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 8px 0px 8px;\n            }\n\n            &__input4 {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 8px 8px 8px;\n            }\n\n            &__add-new-template {\n                margin-top: 30px;\n            }\n\n            &__add-new-template-input {\n                display: flex;\n            }\n\n            &__label {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__holiday-allowance {\n                margin-top: 30px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 24px;\n                color: #333333;\n            }\n\n            &__amount {\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 0px 8px 8px 0px;\n                width: 250%;\n            }\n\n            &__percentage {\n                position: relative;\n                z-index: 0;\n                width: 100%;\n\n                &__icon {\n                    position: absolute;\n                    right: 20px;\n                    top: 15px;\n                }\n            }\n\n            &__pay-percentage-input {\n                width: 100%;\n                height: 56px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 0px 8px 8px 0px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 24px;\n                padding-left: 10px;\n            }\n\n            &__existing-template {\n                margin-top: 30px;\n\n                &__td {\n                    width: 100px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 500;\n                    font-size: 16px;\n                    line-height: 22px;\n                    color: #999999;\n                }\n\n                &__text {\n                    display: flex;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 16px;\n                    line-height: 24px;\n                    color: #505054;\n                }\n\n                &__label {\n                    margin-right: 10px;\n                }\n            }\n        }\n\n        &__extend {\n            margin-top: 40px;\n\n            &__way-of-work {\n                display: flex;\n                margin-top: 20px;\n                justify-content: space-between;\n                align-items: center;\n\n                &__left {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                }\n\n                &__span {\n                    margin-left: 10px;\n                }\n\n                &__right {\n                    width: 75%;\n                }\n\n                &__time {\n                    display: flex;\n                    width: 100%;\n                }\n\n                &__rest-include {\n                    width: 100%;\n                    padding-left: 10px;\n                }\n\n                &__buttons {\n                    display: flex;\n\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 16px;\n                    line-height: 24px;\n                    text-align: center;\n                    color: #505054;\n                }\n\n                &__fix {\n                    border-radius: 8px 0px 0px 8px;\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    text-align: center;\n                    padding-top: 15px;\n                    color: #505054;\n                }\n\n                &__fix-selected {\n                    border-radius: 8px 0px 0px 8px;\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    background: #4a515e;\n                    text-align: center;\n                    padding-top: 15px;\n                    color: #ffffff;\n                }\n\n                &__fix:hover {\n                    border-radius: 8px 0px 0px 8px;\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    text-align: center;\n                    padding-top: 15px;\n                    background: #4a515e;\n                    color: #ffffff;\n                    cursor: pointer;\n                }\n\n                &__optional {\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    text-align: center;\n                    padding-top: 15px;\n                    color: #505054;\n                }\n\n                &__optional-selected {\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    text-align: center;\n                    padding-top: 15px;\n                    background: #4a515e;\n                    color: #ffffff;\n                }\n\n                &__optional:hover {\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    text-align: center;\n                    padding-top: 15px;\n                    background: #4a515e;\n                    color: #ffffff;\n                    cursor: pointer;\n                }\n\n                &__autonomous {\n                    border-radius: 0px 8px 8px 0px;\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    text-align: center;\n                    padding-top: 15px;\n                    color: #505054;\n                }\n\n                &__autonomous-selected {\n                    border-radius: 0px 8px 8px 0px;\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    text-align: center;\n                    padding-top: 15px;\n                    background: #4a515e;\n                    color: #ffffff;\n                }\n\n                &__autonomous:hover {\n                    border-radius: 0px 8px 8px 0px;\n                    height: 56px;\n                    border: 1px solid #e1e1e1;\n                    width: 100%;\n                    text-align: center;\n                    padding-top: 15px;\n                    background: #4a515e;\n                    color: #ffffff;\n                    cursor: pointer;\n                }\n\n                &__info-message {\n                    margin-top: 5px;\n                    display: flex;\n                    align-items: center;\n                    position: relative;\n\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 500;\n                    font-size: 12px;\n                    color: #999999;\n\n                    &__text {\n                        margin-left: 5px;\n                    }\n                }\n            }\n\n            &__optional {\n                margin-top: 20px;\n\n                &__left {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                    margin-top: 20px;\n                }\n\n                &__span {\n                    margin-left: 10px;\n                }\n\n                &__content {\n                    margin-top: 20px;\n                    background: #fafafa;\n                    border: 1px solid #f2f2f2;\n                    border-radius: 8px;\n                    padding: 0px 20px 20px 20px;\n                }\n\n                &__row {\n                    display: flex;\n                    margin-top: 20px;\n                }\n\n                &__left {\n                    width: 25%;\n                    display: flex;\n                    align-content: center;\n                }\n\n                &__text {\n                    padding-left: 10px;\n                    padding-right: 10px;\n\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                }\n\n                &__right {\n                    display: flex;\n                    width: 75%;\n                }\n\n                &__button {\n                    width: 100%;\n                }\n\n                &__recurring-schedule-card {\n                    margin-top: 20px;\n                }\n            }\n\n            &__template {\n                &__left {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                    margin-top: 20px;\n                }\n\n                &__span {\n                    margin-left: 10px;\n                }\n\n                &__label {\n                    margin-top: 20px;\n                }\n\n                &__td {\n                    padding-left: 20px;\n                }\n\n                &__text {\n                    margin-top: 20px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                }\n            }\n        }\n    }\n\n    &__list {\n\n        &__plus {\n\n            display: flex;\n            margin-top: 20px;\n            flex-direction: column;\n            align-items: center;\n\n            &__button {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                background: white;\n                height: 40px;\n                width: 120px;\n                color: #49ae9e;\n                font-size: 16px;\n                font-weight: 500;\n    \n                border: 1px solid #49ae9e;\n                border-radius: 8px;\n                cursor: pointer;\n            }\n        }\n\n        .scheduleInfo {\n\n            .section {\n                display: flex;\n                margin-top: 20px;\n            }\n\n            .label {\n                text-align: left!important;\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 20px;\n                color: #868686;\n                position: relative;\n                width: 132px;\n            }\n\n            .value {\n                flex: 1;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #333333;\n                display: inline-block;\n            }\n\n            .remove {\n                button {\n                    padding: 3px;\n                    color: #e47c77;\n                    font-size: 13px;\n\n                    &:hover {\n                        text-decoration: underline;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.css-1p3m7a8-multiValue {\n    background: none !important;\n}\n\n.react-select__multi-value__remove {\n    display: none !important;\n}\n\n.whiteSpace {\n    height: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
